import * as Yup from 'yup';
import { Draft } from '@models';

export function useValidationSchema() {
  return Yup.object<Draft>().shape({
    name: Yup.string().nullable().required(),
  });
}
